// extracted by mini-css-extract-plugin
export default {"container":"Frame_container__ve9r8"};